export enum FiChecklist2ReportType {
    OpenChecklists = 0,
    AttentionRequired = 1, // Deviations
    RecentActivity = 2,
    PastChecklists = 3, // ChecklistHistory
}

export enum FiChecklist2ReportDeviationTaskType {
    AutomatedTask,
    OneTimeTask,
}

export enum ChecklistProgressType {
    InProgress,
    NotStarted,
    Completed,
}

export enum WidgetTableFilterType {
    Common,
    OpenChecklistsSummary,
    DeviationCheckpoints,
    RecentActivity,
    History,
    UnitBenchmarkByChecklists,
    UnitBenchmarkByCheckpointGroups,
    UnitBenchmarkByCheckpoints,
    RecentActivityCheckpointDetails,
    ChecklistOpenAttachmentsList,
    ChecklistHistoryAttachmentsList,
}
